import React from 'react';
import { connect } from 'react-redux';
import { selectModel, selectResources } from '../store/selectors';

const PriceBarView = ({ resources, dealPrice, show }) => {
    // flos-pricebar would automatically look for `Accordion` class and scroll into it when clicked, so no work here to make that works
    return (
        <flos-pricebar
            shown={show}
            show-about-price
            price-label={resources.pricebarPrice}
            price={dealPrice}
            rate-label={resources.pricebarRate}
            about-label={resources.pricebarAbout}
        />
    );
};

const mapStates = state => {
    const model = selectModel(state);

    return {
        resources: selectResources(state),
        show: !!model,
        dealPrice: model && model.dealPrice
    };
};

export const PriceBar = connect(mapStates)(PriceBarView);
